<template>
  <div id="tab-doc">
    <spinner-round :isLoading="loading"></spinner-round>
    <div v-if="program && !loading" class="">
			<div class="tabs is-separatedUnderlined has-bg-white is-fullwidth is-marginless is-border">
				<ul class="has-text-weight-medium">
					<li :class="{'is-active':panel === 'DOCS'}"><a class="is-uppercase" @click="panel = 'DOCS'">Documents Programme</a>
					</li>
					<li :class="{'is-active':panel === 'DOCS_FLUX'}" v-if="program && program.from_flux">
						<a class="is-uppercase" @click="panel = 'DOCS_FLUX'">Documents issus du flux promoteur</a>
					</li>
          <li :class="{'is-active':panel === 'DOCS_CONTRAT'}">
						<a class="is-uppercase" @click="panel = 'DOCS_CONTRAT'">Documents contrat de réservation</a>
					</li>
				</ul>
			</div>
			<div class="has-bg-annonce is-padding-left is-padding-right" v-show="panel === 'DOCS_FLUX'">
				<div class="has-text-white is-size-6">
					<span class="icon is-medium is-size-7"><i class="fas fa-rss fa-s"></i></span>
					<i>Ces informations sont automatiquement mises à jour.</i>
				</div>
			</div>
			<form @submit.prevent.stop="submit">
				<div v-show="panel === 'DOCS'">
					<div class="columns is-multiline">
						<div class="column is-12 is-border-left is-border-right has-bg-white">
							<div class="title is-5">
								<b class="is-uppercase">Brochure du programme</b>
                <span class="is-padding-left-xsmall" v-helper.bottom="'48pvPnXWhfMnF10pIqZ4tj'">
                  <i class="fal fa-info-circle"></i>
                </span>
							</div>
						</div>
						<div class="column is-12 is-paddingless">
							<div class="field">
                <upload-file @upload="val => uploadDocument(val, 'Brochure du programme')"
                             @deleteDocuments="DeleteBrochure"
                             :custom-id="'brochure'"
                             :documents="brochure"
                             :multiple="false"
                             :canDrag="false"
                             :unique="true"
                ></upload-file>
              </div>
            </div>
            <div class="column is-12 is-border-left is-border-right has-bg-white">
              <div class="title is-5">
                <b class="is-uppercase">Dossier de réservation</b>
                <span class="is-padding-left-xsmall" v-helper.bottom="'48pvPnXWhfMnF10pIqZ4tj'">
                  <i class="fal fa-info-circle"></i>
                </span>
              </div>
            </div>
            <div class="column is-12 is-paddingless">
              <div class="field">
                <upload-file @upload="val => uploadDocument(val, 'Dossier de réservation')"
                             :custom-id="'reservation'"
                             @deleteDocuments="DeleteDossierResa"
                             :documents="reservation"
                             :multiple="false"
                             :canDrag="false"
                             :unique="true"
                ></upload-file>
              </div>
            </div>
          </div>
          <div class="columns is-multiline is-margin-top">
            <div class="column is-12  is-border-top is-border-right is-border-left has-bg-white">
              <div class="title is-5">
                <b class="is-uppercase">Documents divers</b>
                <span class="is-padding-left-xsmall" v-helper.bottom="'48pvPnXWhfMnF10pIqZ4tj'">
                  <i class="fal fa-info-circle"></i>
                </span>
              </div>
            </div>
            <div class="column is-12 is-paddingless">
              <div class="field">
                <upload-file @upload="uploadDocument"
                             :custom-id="'divers'"
                             :documents="otherDocuments"
                             :default-names="programDocumentsNameData"
                             :excludes-names="excludesNames"
                             :canDrag="false"
                             @deleteDocuments="deleteDocuments"
                             :isSquareInput="true"
                ></upload-file>
              </div>
            </div>
          </div>
        </div>
        <div v-show="panel === 'DOCS_FLUX'">
          <div class="columns is-multiline">
            <div class="column is-12 has-bg-white">
              <div class="title is-5">
                <b class="is-uppercase">Documents</b>
              </div>
            </div>
            <div class="column is-12 is-paddingless">
              <div v-if="documentsFlux && documentsFlux.length" class="field">
                <view-file-list :documents="documentsFlux" :fromFlux="true" :isArray="true"></view-file-list>
              </div>
              <div v-else>
                <div>Le promoteur ne fournit pas de document pour ce programme.</div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="panel === 'DOCS_CONTRAT'" class="has-bg-white is-margin-bottom">
          <div class="has-bg-white is-border-bottom is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small is-border">
            <span class="is-uppercase is-size-6">LISTE DES DOCUMENTS ANNEXÉS AU CONTRAT DE RÉSERVATION</span>
            <span class="is-padding-left-xsmall" v-helper.bottom="'48pvPnXWhfMnF10pIqZ4tj'">
              <i class="fal fa-info-circle"></i>
            </span>
          </div>
          <div class="notification is-warning is-padding-left is-marginless is-min-height-50 is-flex">
            <div class="is-self-centered has-text-weight-medium has-text-left w100 is-uppercase is-size-7">
              <b>INFORMATION </b>: LES FICHIER LIÉS SEROnT AUTOMATIQUEMENT AJOUTÉ AU CONTRAT DE RÉSERVATION
            </div>
          </div>
          <div id="document-list-item" class="is-margin is-border">
            <div v-dragula="program.adv_documents" drake="one">
              <document-list-item v-for="(doc, idx) in program.adv_documents"
                                  :source="doc"
                                  :key="doc.value + '-document'"
                                  :index="idx"
                                  :open-input="true"
                                  :canDrag="true"
                                  :selected-row="selectedRow"
                                  @update="submit"
                                  @selectedRow="val => selectedRow = val"
                                  @remove="removeContratDocument">
              </document-list-item>
            </div>
            <div class="row-width-actions-bar">
              <button class="page-header-btn button is-grey-dark is-fullwidth is-radiusless" @click="addNewAnnexDocument">
                <span>Ajouter un document à la liste</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { DefaultValues } from '@/mixins'
  import { compact, uniq, isNil } from 'lodash'
  import DocumentListItem from '../adv/DocumentListItem'
  
  const uuidv4 = require('uuid/v4')

  export default {
    name: 'ProgramDocumentTab',
    props: {
      source: {
        type: Object,
        required: true
      },
      selectPanel: {
        type: String,
        default: 'DOCS'
      }
    },
    data () {
      return {
        selectedRow: null,
        program: null,
        loading: false,
        id: null,
        panel: 'DOCS',
        documents: [],
        route: this.$route
      }
    },
    components: {DocumentListItem},
    mixins: [DefaultValues],
    computed: {
      brochure () {
        if (this.program.documents && this.program.documents.length) {
          return compact([
            this.program.documents
              .find(x => !isNil(x) && x.filename ? x.filename === 'Brochure du programme' : false)
          ])
        } else return []
      },
      reservation () {
        if (this.program.documents && this.program.documents.length) {
          return compact([
            this.program.documents
              .find(x => !isNil(x) && x.filename ? x.filename === 'Dossier de réservation' : false)
          ])
        } else return []
      },
      otherDocuments () {
        if (this.program.documents && this.program.documents.length) {
          return compact(
            this.program.documents
              .filter(x => {
                if (!isNil(x) && x.filename) return !['Brochure du programme', 'Dossier de réservation'].includes(x.filename)
                else return true
              })
          )
        } else return []
      },
      excludesNames () {
        if (this.program.documents && this.program.documents.length) {
          return uniq(compact(
            this.program.documents
              .map(x => x.filename)
              .concat(this.brochure ? this.brochure.filename : null)
              .concat(this.reservation ? this.reservation.filename : null)
          ))
        }
      },
      documentsFlux () {
        if (this.program && this.program.documents_flux && this.program.documents_flux.length > 0) {
          return this.program.documents_flux
        } else return []
      }
    },
    methods: {
      DeleteDossierResa (doc) {
        let idx = this.program.documents.findIndex(x => x.filename === 'Dossier de réservation')
        this.program.documents.splice(idx, 1)
        this.submit()
      },
      DeleteBrochure (doc) {
        let idx = this.program.documents.findIndex(x => x.filename === 'Brochure du programme')
        this.program.documents.splice(idx, 1)
        this.submit()
      },
      removeContratDocument (idx) {
        this.program.adv_documents.splice(idx, 1)
        this.submit()
      },
      addNewAnnexDocument () {
        this.program.adv_documents.push({
          name: `Nouveau Document ${this.program.adv_documents.length + 1}`,
          value: `new_document_${uuidv4()}`,
          document: null
        })
        this.submit()
      },
      submit () {
        this.program.documents = compact(this.otherDocuments.concat(this.brochure, this.reservation))
        let programDocuments = this.program.documents
        let advDocuments = this.program.adv_documents

        this.$emit('submitDocument', programDocuments, advDocuments)
      },
      deleteDocuments (document) {
        let idx = this.program.documents.findIndex(x => x.filename === document.filename)
        this.program.documents.splice(idx, 1)
        this.submit()
      },
      uploadDocument (files, filename) {
        if (files.cropped) {
          console.log(files)
          if ('filename' in files && (files.filename === 'Brochure du programme' || files.filename === 'Dossier de réservation')) {
            let index = this.program.documents.findIndex(x => x.filename === files.filename)
            this.program.documents.splice(index, 1, files[0])
          } else {
            this.program.documents.splice(files.croppedIndex, 1, files[0])
          }
        } else {
          files.forEach((file) => {
            let _filename
            if (filename) {
              _filename = filename
            } else if (file.filename) {
              _filename = file.filename
            } else {
              _filename = 'Nouveau document'
            }
            let hostedFile = Object.assign({}, file, { filename: _filename })
            this.program.documents.push(hostedFile)
          })
        }
        console.log('this.program.documents > ', this.program.documents)
        this.submit()
      },
      initValues (program) {
        if (!Array.isArray(program.documents)) program.documents = [program.documents]
        this.submit()
      }
    },
    created () {
      this.program = Object.assign({}, this.source)
      this.id = this.source.pk
      if (this.selectPanel) {
        this.panel = this.selectPanel
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/ProgramDocumentTab.vue